export default "__VITE_ASSET__DjmnuY9s__"